import { createTheme } from '@mui/material/styles';
import '@fontsource/vazirmatn';
import { toPersianDigits } from './utils/helpers';
const theme = createTheme({
  palette: {
    mode: 'light',
    action: {
      disabledBackground: '#707070',
      disabled: '#FFFFFF'
    },
    primary: {
      main: '#ffcb74',
    },
    secondary: {
      main: '#B85EE1',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
      dark: '#2e2e2e',
      whiteOpacity: 'rgba(255, 255, 255, 0.15)',
      gray: '#6f6f6f',
      harmony: '#d5d5d5',
    },
    text: {
      default: '#000000',
      dark: '#2e2e2e',
      harmony: '#d5d5d5',
      gray: '#6f6f6f',
      secondary: '#ffffff',
      disabled: '#707070',
    },
    success: {
      main: '#16db65',
    },
    error: {
      main: '#ff2323',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#ffc107',
    }
  },
  gradients: {
    dark: 'linear-gradient(135deg, #2e2e2e 30%, #4d4d4d 98%)',
    gold: 'linear-gradient(135deg, #ffcb74 30%, #f5e0b7  95%)',
    background: 'linear-gradient(180deg, #f5f5f5, #d5d5d5)',
  },
  typography: {
    fontFamily: 'Vazirmatn, sans-serif',
    fontSize: 14, // Base font size
    color: '#000000',
    title: {
      fontSize: '24px',
      fontWeight: 500,
    },
    body1: {
      fontSize: '20px',
      fontWeight: 400,
    },
    caption: {
      fontSize: '18px',
      fontWeight: 400,
    },
    caption2: {
      fontSize: '14px',
      fontWeight: 400,
    },
    subtitle: {
      fontSize: '12px',
      fontWeight: 400,
    },
    subtitle2: {
      fontSize: '10px',
      fontWeight: 300,
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: '12px',
          textTransform: 'none', // Disable uppercase transformation
          fontWeight: 500, // Medium font weight for better readability
          boxShadow: 'none'
        },
        text: {
          color: '#000000',
        },
        contained: {
          backgroundColor: '#ffcb74',
          color: '#000000', // Deep Black text color for contrast
          // '&:hover': {
          //   backgroundColor: 'transparent', // Dark Gold background on hover
          // },
        },
        outlined: {
          borderColor: '#ffcb74', // Gold border color for outlined buttons
          color: '#000000', // Golden White text color
          '&:hover': {
            borderColor: '#ffcb74', // Dark Gold border color on hover
            backgroundColor: '#transparent', // Harmony background on hover
          },
        }
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: '16px',
          color: '#000000',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          fontSize: '16px', // Font size for input text
          color: '#000000', // Golden White for input text
        },
        notchedOutline: {
          borderColor: '#000000',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '14px',
          color: '#2e2e2e',
          '&.Mui-focused': {
            color: '#000000',
          },
        },
        shrink: {
          fontSize: '12px',
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          backgroundColor: '#f5f5f5', // Custom background color for Tabs
          borderBottom: '1px solid #d5d5d5', // Border between tabs
        },
        indicator: {
          backgroundColor: '#ffcb74', // Custom indicator color
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: '16px',
          fontWeight: 600,
          color: '#333', // Custom text color for Tab labels
          '&.Mui-selected': {
            color: '#ffcb74', // Color when Tab is selected
          },
        },
      },
    },
    MuiSkeleton: {
      styleOverrides: {
        root: {
          backgroundColor: '#6f6f6f',
        },
      },
    },
    MuiPagination: {
      styleOverrides: {
        root: {
          direction: 'rtl',  // Right-to-left direction globally
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '16px',  // Margin to add spacing between other components
          '&.Mui-selected': {
            backgroundColor: 'primary.main',
            fontWeight: 'bold',
          }
        },
        '&.Mui-disabled': {
          color: 'text.disabled',
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          color: 'text.primary', 
          '&:hover': {
            backgroundColor: 'primary.light',
          },
        },
      },
    }
  },
});

export default theme;
